import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import "./App.css";
import ChatWindow, { ChatWindowRef } from "./pages/ChatWindow.tsx";
// @ts-ignore
import { ChannelPromptModal } from "./components/channel-prompt-modal/channel-prompt-modal.tsx";

import "./styles/styles.scss";

// App content wrapper that handles URL parameter detection
const AppContent = () => {
  const [showChannelPrompt, setShowChannelPrompt] = useState(false);
  const location = useLocation();
  const chatWindowRef = useRef<ChatWindowRef>(null);

  // Check for prompt_channel parameter on mount and location change
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const promptChannel = urlParams.get("prompt_channel");

    if (promptChannel === "true") {
      setShowChannelPrompt(true);
    } else {
      setShowChannelPrompt(false);
    }
  }, [location.search]);

  // Handle web selection - close modal and let user continue on web
  const handleChatSelected = () => {
    setShowChannelPrompt(false);
    // Just close the modal, don't open chat
  };

  // Handle SMS selection - open messaging app
  const handleSmsSelected = () => {
    const config = chatWindowRef.current?.get_config();
    if (config?.sms_phone_number && config?.sms_message) {
      const smsUrl = `sms:${config.sms_phone_number}?body=${encodeURIComponent(config.sms_message)}`;
      // Open SMS app
      window.open(smsUrl, "_blank");
    }
    // Close modal
    setShowChannelPrompt(false);
  };

  // Get brand logo from config
  const getBrandLogo = () => {
    const config = chatWindowRef.current?.get_config();
    return config?.brand_logo || "";
  };

  return (
    <>
      <ChatWindow ref={chatWindowRef} />
      {/* Channel Prompt Modal */}
      {showChannelPrompt && (
        <ChannelPromptModal
          onChatSelected={handleChatSelected}
          onSmsSelected={handleSmsSelected}
          brandLogo={getBrandLogo()}
        />
      )}
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
